// @flow
import React from 'react'
import { FormField, StyledField, StyledInput, Label, Error } from 'src/components/Form'
import type { Field as FieldProps } from 'src/types'

const renderNativeDatePicker = ({
  className,
  input,
  label,
  type,
  options,
  placeholder,
  autocomplete,
  meta: { touched, error }
}: FieldProps) => (
  <FormField className={className}>
    <Label>{label}</Label>
    <StyledField hasError={touched && error}>
      <StyledInput
        {...input}
        className="input"
        placeholder={placeholder}
        options={options}
        type={'date'}
        autoComplete={autocomplete}
      />
      {touched && error && <Error>{error}</Error>}
    </StyledField>
  </FormField>
)

export default renderNativeDatePicker



// WEBPACK FOOTER //
// ./src/helpers/fieldRenderers/NativeDatePicker.js